// extracted by mini-css-extract-plugin
module.exports = {"mask":"index_mask__1zRYL","container":"index_container__3fUmS","img":"index_img__LfMzI","tips":"index_tips__V9Trh"};